export default "__VITE_ASSET__dec6d860__"